module.exports = __webpack_public_path__ + "img/Lock-With-Key.85d026bd.svg";